import {useState, useEffect, useRef, useCallback} from "react";
import {inject, observer} from "mobx-react";
import {db} from "../../../../firebase/Firebase";
import Alerts from "../../../../palette/Alerts";
import {LayoutChild} from "../../../../palette/Palette";
import {Animated} from "react-animated-css";
import PassengersManagementsGrid from "./PassengersManagementsGrid";
import './passengeres.css'
import PassengersManagementForm from "./PassengersManagementForm";
import PassengersManagementFormEdit from "./PassengerManagementFormEdit";
import ManualReservation from "./manual-reservation/ManualReservation";
import Parcels from "./parcels/Parcels";

const options = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
};

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function PassengersManagements(props) {

    const {DataStore, ControlStore} = props
    const {companyName, idCompany,} = DataStore
    const {driverFinished} = ControlStore

    const [load, setLoad] = useState(true)
    const [dataSource, setDataSource] = useState([])
    const [visibleGrid, setVisibleGrid] = useState(true)
    const [visibleForm, setVisibleForm] = useState(false)
    const [edit, setEdit] = useState(false)
    const [trigger, setTrigger] = useState(false)
    const [dataEdit, setDataEdit] = useState(null)
    const [reservationManual, setReservationManual] = useState(false)
    const [dataPassengers, setDataPassengers] = useState([]);
    const [viewport, setViewport] = useState(null);
    const [parcels, setParcels] = useState(false);
    const [express, setExpress] = useState(false);

    const isMounted = useMountedState()

    useEffect(() => {
        const GetPassengerManagement = async () => {
            const newArray = [];
            let ID = 0
            await db.collection(companyName).doc(idCompany).collection('PassengersManagement')
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if (doc.exists) {
                            ID = ID + 1
                            const obj = {...doc.data(), docId: doc.id, ID: ID};
                            newArray.push(obj);
                            setLoad(true)
                        } else {
                            setLoad(true)
                            setDataSource([]);
                        }
                    });
                    setDataSource(newArray);
                })
                .catch(function () {
                    setDataSource(newArray);
                });
        };
        if (isMounted()) {
            GetPassengerManagement().catch(() => setTrigger(!trigger));
        }
    }, [companyName, idCompany, isMounted, trigger]);

    useEffect(() => {

        if (isMounted()) {
            function success(pos) {
                const crd = pos.coords;
                if (crd.latitude !== 0 && crd.longitude !== 0) {
                    setViewport({...viewport, latitude: crd.latitude, longitude: crd.longitude});
                }
            }

            function error(err) {
                console.warn('ERROR(' + err.code + '): ' + err.message);
            }

            navigator.geolocation.getCurrentPosition(success, error, options);
        }
    }, [isMounted]);

    return (
        <>
            {!driverFinished &&
            <LayoutChild color='transparent' percent={95} margin='auto' top={25}>
                <Alerts severity="warning" body={'No se han gestionado conductores!'}/>
            </LayoutChild>
            }


            {(visibleGrid && driverFinished) &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleGrid}>
                <PassengersManagementsGrid load={load} dataSource={dataSource} setEdit={setEdit}
                                           setVisibleForm={setVisibleForm} setVisibleGrid={setVisibleGrid}
                                           setDataEdit={setDataEdit} DataStore={DataStore} setTrigger={setTrigger}
                                           trigger={trigger} setReservationManual={setReservationManual}
                                           setDataPassengers={setDataPassengers} setParcels={setParcels}
                                           setExpress={setExpress}/>
            </Animated>}

            {visibleForm &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleForm}>
                <PassengersManagementForm setVisibleForm={setVisibleForm} setVisibleGrid={setVisibleGrid}
                                          setDataEdit={setDataEdit} DataStore={DataStore} setTrigger={setTrigger}
                                          dataSource={dataSource}/>
            </Animated>}

            {edit &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={edit}>
                <PassengersManagementFormEdit setEdit={setEdit} setVisibleGrid={setVisibleGrid} dataArray={dataSource}
                                              dataSource={dataEdit} DataStore={DataStore} setTrigger={setTrigger}
                />
            </Animated>}


            {reservationManual &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={reservationManual}>
                <ManualReservation setReservationManual={setReservationManual} setVisibleGrid={setVisibleGrid}
                                   dataArray={dataSource} dataSource={dataEdit} DataStore={DataStore}
                                   setTrigger={setTrigger} dataPassengers={dataPassengers} setViewport={setViewport}
                                   viewport={viewport}
                />
            </Animated>}

            {parcels &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={parcels}>
                <Parcels setViewport={setViewport} viewport={viewport} setParcels={setParcels} DataStore={DataStore}
                         dataPassengers={dataPassengers} dataArray={dataSource} setVisibleGrid={setVisibleGrid}
                />
            </Animated>
            }


        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(PassengersManagements));